import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";
import { Api } from "services/api/api.service";
import { SubscriptionInfo } from "model/Company";
import { SimflexityPayCompany } from "web-apps/company/pages/payments/simflexityPay/simflexityPay";
import { SubscriptionTerms } from "./subscriptionTerms.component";
import {
  SubscriptionCard,
  SubscriptionCardTitle,
  SubscriptionPageLayout,
  SubscriptionValue,
} from "./companySubscription.styled";
import { SettingsV2PageTitle } from "../companySettingsV2.styled";

export const CompanySubscription: React.FC = () => {
  const { t } = useTranslation();
  const [companyState] = useCompanyStore();
  const [subscriptionInfo, setSubscriptionInfo] = useState<SubscriptionInfo>({
    companyId: companyState.company?.id,
    expirationDate: "",
    membershipDisplayName: "",
    membershipType: "",
    membershipTypeId: "",
    membershipTypekey: "",
  });

  useEffect(() => {
    if (companyState.company?.id) {
      Api()
        .company.getCompanySubscriptionInfo(companyState.company?.id)
        .then((res) => {
          setSubscriptionInfo(res.data);
        });
    }
  }, [companyState.company?.id]);

  return (
    <SubscriptionPageLayout>
      <SettingsV2PageTitle>
        {t("ProfileCompany.Subscription")}
      </SettingsV2PageTitle>

      <SubscriptionCard>
        <SubscriptionCardTitle>
          {t("ProfileCompany.Subscription")}
        </SubscriptionCardTitle>
        <SubscriptionValue>
          {t(`${subscriptionInfo.membershipDisplayName}`)}
        </SubscriptionValue>
      </SubscriptionCard>

      <SubscriptionCard>
        <SubscriptionCardTitle>
          {t("CompanyUsers.Payments")}
        </SubscriptionCardTitle>
        {companyState.company && (
          <SimflexityPayCompany
            companyId={companyState.company.id.toString()}
            variant="settings"
            showTitle={false}
          />
        )}
      </SubscriptionCard>

      <SubscriptionCard>
        <SubscriptionTerms />
      </SubscriptionCard>
    </SubscriptionPageLayout>
  );
};
